// eslint-disable-next-line import/no-extraneous-dependencies
import { SuspedableResource, SuspenderState } from '@olxeu-a2b/delivery-utils/typings/extras';

export default function suspendable<T>(deferedValue: Promise<T>): SuspedableResource<T> {
  const state: SuspenderState<T> = {
    status: 'pending',
    result: null,
  };

  const suspender = deferedValue.then(
    res => {
      state.status = 'success';
      state.result = res;
    },
    error => {
      state.status = 'error';
      state.result = error;
    },
  );
  return {
    read() {
      const { status, result } = state;
      switch (status) {
      case 'pending':
        throw suspender;

      case 'error':
        throw result;

      default:
        return result;
      }
    },
  };
}
